import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;
const API_KEY = process.env.VUE_APP_API_KEY;

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  'Authorization': 'Bearer ' + API_KEY
};

async function login(user) {
  const response = await axios.post(API_URL + '/backoffice/login',
    {
      username: user.username,
      password: user.password
    }, { headers });
    
  if (response.data.data) {
    localStorage.setItem('token', response.data.data.token);
    localStorage.setItem('backoffice-user', JSON.stringify(response.data.data));

  }
  return response.data;
}

async function logout() {
  try {
    await axios.post(API_URL + '/logout', {}, { headers: authHeader() });
  } finally {
    localStorage.removeItem('token');
    localStorage.removeItem('backoffice-notif');
  }
}

async function register(user) {

  const response = await axios.post(API_URL + '/register',
    {
      name: user.name,
      email: user.email,
      password: user.password,
      password_confirmation: user.confirm_password,
    }, { headers });

  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
  }
  return response.data;
}

async function forgotPassword(data) {
  const response = await axios.post(API_URL + '/password-forgot',
    {
      email: data.email,
      redirect_url: data.redirect_url
    }, { headers });

  return response.data;
}

async function resetPassword(data) {
  const response = await axios.post(API_URL + '/password-reset',
    {
      password: data.password,
      password_confirmation: data.password_confirmation,
      email: data.email,
      token: data.token
    }, { headers });

  return response.data;
}

export default {
  login,
  logout,
  register,
  forgotPassword,
  resetPassword
};